import React from "react";
import "../style.css";

export default function Card({ title, description, icon }) {
  return (
    <article className="card">
      <div className="head">
        <h3 className="h4">{title}</h3>
        {icon ? <span style={{ backgroundImage: `url(${icon})` }} className="icon" aria-hidden="true" /> : null}
      </div>
      <div className="body"><p className="bodycopy">{description}</p></div>
    </article>
  );
}
